import { useState } from 'react';
import { useServices } from '@/app/providers';
import { isSectionAdmin, useAbility } from '@/modules/identity/application/ability';
import {
  ReportsIndexPage,
  AccountStatementPage,
  DelinquentReportPage,
  AnnualBillingPage,
  IncomeExpenseReportPage,
  MonthlyStatementPage,
  JournalPage,
  BankReconciliationPage,
  type ReportType,
} from '@/modules/reports';

export const Reports = () => {
  const ability = useAbility();
  const { currentUser } = useServices();
  // El admin de sección ve los mismos reportes, acotados a su sección por el backend.
  const isAdmin = ability.can('manage', 'all') || isSectionAdmin(currentUser);

  const [currentReport, setCurrentReport] = useState<ReportType | null>(null);

  const handleNavigate = (reportType: ReportType) => {
    // For admin-only reports, verify permission
    if (
      [
        'delinquent',
        'annual-billing',
        'income-expense',
        'monthly-statement',
        'journal',
        'bank-reconciliation',
      ].includes(reportType) &&
      !isAdmin
    ) {
      return;
    }
    setCurrentReport(reportType);
  };

  const handleBack = () => {
    setCurrentReport(null);
  };

  switch (currentReport) {
    case 'account-statement':
      return <AccountStatementPage onBack={handleBack} />;
    case 'delinquent':
      return isAdmin ? <DelinquentReportPage onBack={handleBack} /> : <ReportsIndexPage onNavigate={handleNavigate} />;
    case 'annual-billing':
      return isAdmin ? <AnnualBillingPage onBack={handleBack} /> : <ReportsIndexPage onNavigate={handleNavigate} />;
    case 'income-expense':
      return isAdmin ? <IncomeExpenseReportPage onBack={handleBack} /> : <ReportsIndexPage onNavigate={handleNavigate} />;
    case 'monthly-statement':
      return isAdmin ? <MonthlyStatementPage onBack={handleBack} /> : <ReportsIndexPage onNavigate={handleNavigate} />;
    case 'journal':
      return isAdmin ? <JournalPage onBack={handleBack} /> : <ReportsIndexPage onNavigate={handleNavigate} />;
    case 'bank-reconciliation':
      return isAdmin ? <BankReconciliationPage onBack={handleBack} /> : <ReportsIndexPage onNavigate={handleNavigate} />;
    default:
      return <ReportsIndexPage onNavigate={handleNavigate} />;
  }
};
